import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { theme } from 'theme';
import LearnerTabs, { LearnerTabDefinition } from './LearnerTabs';
import { FlexCol } from 'components/Elements';

type TabComponentProps = {
    tabs: LearnerTabDefinition[];
    initialActiveTabId?: string;
};

export default function LearnerImmersiveTabs({ tabs, initialActiveTabId }: TabComponentProps): JSX.Element {
    const { step } = useContext(LearnerCourseContext);

    const [activeTabId, setActiveTabId] = React.useState<string>(() => {
        if (step.id && tabs.some((t) => t.id === step.id)) return step.id;
        if (initialActiveTabId) return initialActiveTabId;
        return tabs[0]?.id ?? '';
    });

    React.useEffect(() => {
        if (!step.id) return;
        if (tabs.some((t) => t.id === step.id)) setActiveTabId(step.id);
    }, [step.id, tabs]);

    const active = tabs.find((t) => t.id === activeTabId);

    return (
        <>
            <LearnerTabs tabs={tabs} activeTabId={activeTabId} onClickTab={(newId: string) => setActiveTabId(newId)} />
            <TabContent id="tabContent">{active ? active.content : null}</TabContent>
        </>
    );
}

const TabContent = styled(FlexCol)`
    background: ${theme.appBackgroundColour};
    width: 100%;
    margin-inline: auto;
    min-width: 0;

    flex: 1 1 auto;
`;
